var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListItemIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.9375,
    cy: 10.2384,
    r: 8.9375,
    stroke: "url(#paint0_linear_103_1780)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3812 6.63302C14.2545 6.50642 14.0493 6.50642 13.9227 6.63302L8.31644 12.2393L6.18151 10.1066L6.18082 10.1059L5.95357 9.87616C5.89289 9.81481 5.81025 9.78018 5.72396 9.77994C5.63767 9.7797 5.55485 9.81387 5.49383 9.87489L5.03541 10.3333C4.9744 10.3943 4.94022 10.4771 4.94046 10.5634C4.9407 10.6497 4.97533 10.7324 5.03668 10.793L5.26579 11.0196L5.26716 11.021L8.08722 13.8436C8.14801 13.9044 8.23048 13.9386 8.31649 13.9386C8.40249 13.9387 8.48498 13.9045 8.5458 13.8437L14.8396 7.54991C14.9004 7.48912 14.9345 7.40666 14.9345 7.32068C14.9345 7.2347 14.9004 7.15224 14.8396 7.09144L14.3812 6.63302Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.648373,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_1780",
    x1: 9.9375,
    y1: 9.01424,
    x2: 5.75,
    y2: 0.300858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3355D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2571DF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListItemIcon);
export default __webpack_public_path__ + "static/media/list-item-icon.047373cb1ab623563047890040e23b89.svg";
export { ForwardRef as ReactComponent };